import ActionTypes from './actionTypes';

const initialState = {
  isEdit: false,
  id: null,
  title: '',
  posX: null,
  posY: null,
  active: true,
  domainName: '',
  subStoryId: '',
  langSrc: 'undefined',
  langScript: 'undefined',
  gptFunctionDetails: {},
  customCodeBlock: '',
  outputJson: {},
  userIntentDescription: '',
  isStartStep: true,
  functionName: '',
  functionDescription: '',
  stepName: '',
  userIntent: '',
  functionParameters: [],
  codeExecutorFunctionName: null,
  inputJSON: '{}',
  aissNodeId: '',
  isAissNodeFetchDataLoading: false,
  envVariables: [],
  stepAndFunctionNameErrors: {},
  customInstructions: {},
  piiMaskedParams: [],
};

export default function reduce(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SET_CUSTOM_INSTRUCTIONS:
      return { ...state, customInstructions: action.data, isEdit: true };
    case ActionTypes.SET_STEP_AND_FUNCTION_ERRORS:
      return { ...state, stepAndFunctionNameErrors: action.data };
    case ActionTypes.SET_ENV_VARIABLES:
      return { ...state, envVariables: action.data };
    case ActionTypes.SET_FETCH_DATA_LOADING:
      return { ...state, isAissNodeFetchDataLoading: action.data };
    case ActionTypes.SET_AISS_NODE_ID:
      return { ...state, aissNodeId: action.data };
    case ActionTypes.SET_NODE_DATA:
      return {
        ...state,
        ...action.data,
      };
    case ActionTypes.RESET_STATE:
      return {
        ...initialState,
      };
    case ActionTypes.SET_DATA:
      return { ...state, isEdit: true };
    case ActionTypes.UPDATE_AISS_NODE_DATA:
      return { ...state, isEdit: action.data };
    case ActionTypes.UPDATE_EDITOR_DATA:
      return { ...state, isEdit: true, customCodeBlock: action.data.code };
    case ActionTypes.SET_STEP_ACTIVE:
      return { ...state, isEdit: true, active: action.data };
    case ActionTypes.SET_STEP_TYPE:
      return { ...state, isEdit: true, isStartStep: action.data };
    case ActionTypes.SET_STEP_TITLE:
      return { ...state, isEdit: true, stepName: action.data };
    case ActionTypes.SET_USER_INTENT:
      return { ...state, isEdit: true, userIntent: action.data };
    case ActionTypes.SET_FUNCTION_NAME:
      return { ...state, isEdit: true, functionName: action.data };
    case ActionTypes.SET_FUNCTION_DESCRIPTION:
      return { ...state, isEdit: true, functionDescription: action.data };
    case ActionTypes.SET_FUNCTION_PARAMETER:
      return { ...state, isEdit: true, functionParameters: action.data };
    case ActionTypes.SET_COORDINATE:
      return { ...state, posX: action.data.x, posY: action.data.y };
    case ActionTypes.SET_PII_MASKED_PARAMS:
      return { ...state, piiMaskedParams: action.data };

    default:
      return state;
  }
}
